import { combineReducers } from 'redux';
import delivery from './delivery';
import login from './login';
import registerFirstStep from './registerFirstStep';
import registerSecondStep from './registerSecondStep';
import myorders from './myorders';
import profile from './profile';
import offers from './offers';
import settings from './settings';
import notifications from './notifications';
import driver from './driver';

export default combineReducers({
    delivery,
    login,
    registerFirstStep,
    registerSecondStep,
    myorders,
    profile,
    offers,
    settings,
    notifications,
    driver
});
